var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"to":_vm.route,"color":_vm.color,"disabled":_vm.disabled,"x-large":"","block":""}},[_c('v-icon',{attrs:{"color":"white","left":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('span',{class:{ 'white--text' : !_vm.disabled}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }